export default __webpack_public_path__ + "static/media/img_baseCotton_flowers.f78845fc.jpg";